import MatterTasks from "@/components/features/matter/tasks/MatterTasks";
import { LoadingSpinner, Text } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { type MatterTaskWithRoles } from "@/hooks/matter-view-models/use-tasks-view-model";
import { type Matter } from "@/lib/types";
import { useState } from "react";

export default function MatterTasksCard({
  tasks,
  matter,
  massTortId,
  taskId,
}: {
  tasks: MatterTaskWithRoles[];
  matter: Matter;
  massTortId?: string;
  taskId?: string;
}) {
  const { hasPagePermission } = useUser();
  const hasViewPermission = hasPagePermission(
    massTortId
      ? PAGE_PERMISSION_KEYS.massTortsDetailTasks
      : PAGE_PERMISSION_KEYS.mattersDetailTasks,
  );
  const [tasksApiCount, setTaskCount] = useState<number | undefined>();
  return (
    <div className="flex h-full min-h-0 w-full flex-col gap-y-4 p-6">
      <Text variant="title" className="flex items-center gap-2">
        {hasViewPermission ? (
          <>
            Tasks
            {tasksApiCount === undefined ? (
              <LoadingSpinner
                className="h-4 w-4"
                aria-label="Loading task count"
              />
            ) : (
              `(${tasksApiCount})`
            )}
          </>
        ) : (
          "Tasks"
        )}
      </Text>
      <div className="flex min-h-0 flex-1 flex-col">
        <MatterTasks
          tasks={tasks}
          matter={matter}
          massTortId={massTortId}
          taskId={taskId}
          showViewToggle={true}
          showSelectTools={true}
          showCreateButton={true}
          defaultVariant="list"
          onTaskCountChange={setTaskCount}
        />
      </div>
    </div>
  );
}
